var ConfirmationTemplatesModule = /** @class */ (function () {
    function ConfirmationTemplatesModule() {
    }
    return ConfirmationTemplatesModule;
}());
export { ConfirmationTemplatesModule };
